<template>
  <Navbar />
  <div class="main_section">
    <div class="title col">
      <h1>
        編輯維修單
      </h1>
    </div>
    <div class="info_wrap col">
      <!-- 申請人員，申請日期 -->
      <div class="fixed_info">
        <div>
          <p>維修編號 : {{ Form.RepairId }}</p>
        </div>
        <div>
          <p>申請人員 : {{ Form.ApplicantNickName }}</p>
        </div>
        <div>
          <p>申請日期 : {{ Form.ApplicationDate }}</p>
        </div>
      </div>
      <div class="content">
        <!-- 資產編號 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              <span>*</span>資產編號：
            </div>
            <input ref="inputElement" type="text" class="form-control" placeholder="請掃描輸入產編" v-model="Form.AssetsId">
          </div>
        </div>
        <!-- 物品名稱 -->
        <div class="col-12">
          <div class="input-group" :class="{ 'mb-4': !wrongStatus }">
            <div class="input-group-prepend">
              物品名稱：
            </div>
            <input ref="inputElement" type="text" class="form-control readonly_box" readonly v-model="Assets.Name">
          </div>
        </div>
        <!-- Error Hint -->
        <div v-show="wrongStatus" class="col-12">
          <div class="input-group">
            <div style="visibility: hidden;" class="input-group-prepend">
              <p>1</p>
            </div>
            <span style="color:rgb(216, 13, 13); font-weight: 700; font-size: 20px;">{{ alertMsg }}</span>
            <input type="text" style="visibility: hidden;" class="form-control">
          </div>
        </div>
        <!-- 維修廠商 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">維修廠商：</div>
            <input ref="inputElement" type="text" class="form-control" placeholder="最多輸入20字" maxlength="20" v-model="Form.RepairCompany">
          </div>
        </div>        
        <!-- 問題描述 -->
        <div class="col-12">
          <div class="input-group d-flex">
            <div class="input-group-prepend">
              問題描述：
            </div>
            <textarea style="height: 200px;" class="form-control" placeholder="最多輸入500字" maxlength="500" v-model="Form.Question"></textarea>
          </div>
        </div>
        <!-- 報修照片上傳 -->
        <div class="col-12 repair_photo_section">
          <div class="input-group mt-3">
            <div class="input-group-prepend">報修照片上傳：</div>
            <div class="mb-3 file_wrap">
              <button class="choose_btn" @click="fileInputs.click()">選擇檔案</button>
              <input type="file" ref="fileInputs" accept="image/*" multiple style="display: none;"
                @change="utilsStore.handleImgChange($event, Form)">
            </div>
          </div>
        </div>
        <!-- 已選擇的檔案 -->
        <div class="col-12 selected_file">
          <div class="input-group">
            <div class="input-group-prepend">已選擇的檔案：</div>
            <div class="file_upload_box">
              <div v-for="(file, index) in Form.viewFile" :key="index" class="file_upload_wrap mb-1">
                <p>{{ file.FileName }}
                  <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;"
                    @click="utilsStore.viewFile(file)" data-bs-toggle="modal" data-bs-target="#viewFile_modal">
                  <img class="trash_icon" src="@/assets/trash.png" style="margin-left: 10px;"
                    @click="utilsStore.deleteImgFile('new', Form, index)">
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 已上傳檔案 -->
        <div class="selected_file col-12">
          <div class="input-group mt-3">
            <div class="input-group-prepend">已上傳的檔案：</div>
            <div class="file_upload_box">
              <div v-for="(file, index) in Form.existFile" :key="index" class="file_upload_wrap mb-1">
                <p>{{ file.FileName }}
                  <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;"
                    @click="utilsStore.viewFile(file)" data-bs-toggle="modal" data-bs-target="#viewFile_modal">
                  <img class="trash_icon" src="@/assets/trash.png" style="margin-left: 10px;"
                    @click="utilsStore.deleteImgFile('exist', Form, index)">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col button_wrap">
        <button class="back_btn" @click="utilsStore.goBack">回上一頁</button>
        <button class="send_btn" :disabled="!canSubmit" :class="{ send_btn_disabled: !canSubmit }" @click="repairStore.submit('edit')">送出</button>
      </div>
    </div>
  </div>
  <view_modal></view_modal>
</template>

<script setup>
import view_modal from '@/components/view_modal.vue';
import { onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import Navbar from '@/components/Navbar.vue';
import { useUtilsStore } from '@/store';
import { storeToRefs } from 'pinia';
import { useRepairStore } from '@/store/repair/_index';
import { useRoute } from 'vue-router';
import { Repair_Edit_Status } from '@/assets/js/enter_status';
const route = useRoute();
const RepairId = route.query.search_id;
const utilsStore = useUtilsStore();
const repairStore = useRepairStore();
const {
  userName,
  today
} = storeToRefs(utilsStore);
const {
  Form,
  Assets,
  alertMsg,
  canSubmit,
  wrongStatus
} = storeToRefs(repairStore);

const fileInputs = ref(null); // dom ref
onMounted(() => {
  utilsStore.getUserName();
  utilsStore.getDate();
  repairStore.$reset();
  repairStore.getDetails(RepairId, Repair_Edit_Status)
});
onUnmounted(() => {
  repairStore.$dispose();
})

// 監聽資產編號的數值變動 -> 搜尋
watch(() => Form.value.AssetsId, (newValue, oldValue) => {
  repairStore.watchAssetsId(newValue, oldValue);
});
</script>


<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.view_icon,
.trash_icon {
  cursor: pointer;
}

.modal {
  .modal-body {
    padding: 20px;
    margin: auto;
  }

  .modal-content {
    margin: auto;
  }

  .modal-input-group-prepend {
    width: auto;
    font-weight: 700;
    font-size: 20px;
  }

  .modal-footer {
    padding: 0 12px 12px;
    border: none;
  }

  .modal-header {
    h5 {
      font-weight: 700;
    }

    background: #528091;
    color: white;
    display: flex;
    justify-content: center;
  }
}

.readonly_box {
  @include readonly_box;
}

.form_search_btn {
  @include form_search_btn;
}

.input-number {
  @include count_btn;
}

span {
  @include red_star;
}

.main_section {
  .info_wrap {
    .fixed_info {
      @include fixed_info;

      p {
        font-size: 20px;
        margin-bottom: 0;
      }
    }

    .content {
      @include content_bg;

      .input-group {

        .form-control,
        .readonly_box {
          height: 37px;
          border-radius: 0;
        }

        .input-group-prepend {
          color: white;
          font-weight: 700;
          font-size: 20px;
          width: 140px;
        }

        .file_wrap {
          display: flex;
          flex-direction: column;

          .choose_btn {
            margin-bottom: 10px;
            @include choose_file_btn;

            &:hover {
              background: #3f608f;
            }
          }
        }
      }
    }

    .selected_file {
      .file_upload_box {
        .file_upload_wrap {
          margin-bottom: 0;
          display: flex;
          word-break: break-word;

          img {
            width: 25px;
            height: 25px;
          }

          p {
            margin-bottom: 0;
            font-weight: 700;
            color: white;

            &::before {
              margin-right: 10px;
              content: "·";
              font-weight: 700;
              color: white;
            }
          }
        }
      }
    }
  }
}

.button_wrap {
  display: flex;
  justify-content: space-between;
  margin: 30px auto 5%;
  width: 210px;

  .back_btn {
    @include back_to_previous_btn;

    &:hover {
      background-color: #5d85bb;
    }
  }
}

.send_btn {
  @include search_and_send_btn;

  &:hover {
    background-color: #5e7aa2;
  }
}

.send_btn_disabled {
  background: #878787;

  &:hover {
    background: #878787;
  }
}

@media only screen and (min-width: 1200px) {
  .main_section {
    .info_wrap {
      margin: 8px auto 5%;
      width: 800px;

      .content {
        .input-group {
          .input-group-prepend {
            text-align: end;
            width: 140px;
          }
        }
      }

      .selected_file {
        .input-group {
          flex-wrap: unset;
        }

        .input-group-prepend {
          white-space: nowrap;
        }
      }
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .main_section {
    .info_wrap {
      margin: 8px auto 5%;
      width: 750px;

      .content {
        .input-group {

          .readonly_box,
          .input-number {
            width: 100%;
          }

          .form-control {
            width: 65%;
          }

          .input-group-prepend {
            text-align: end;
            width: 140px;
          }
        }
      }

      .selected_file {
        .input-group {
          flex-wrap: unset;
        }

        .input-group-prepend {
          white-space: nowrap;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .main_section {

    .readonly_box,
    .input-number,
    .form-control,
    .file_wrap {
      margin-left: unset !important;
    }

    .form_search_btn {
      border: none;
      color: white;
      width: 60px;
      height: 35px;
      margin-left: unset !important;
      margin-top: 10px;
      font-weight: 700;
      padding: 0 10px;
      background-color: #132238;

      &:hover {
        background-color: #43546d;
      }
    }

    .info_wrap {
      padding: 0 5%;

      .fixed_info {
        height: unset;
        flex-direction: column;
        padding: 10px;
      }

      .content {
        .input-group {
          flex-direction: column;

          .input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
            margin-left: unset;
            border-radius: 5px;
            margin-top: 5px;
            height: 35px;
          }

          .form-control {
            width: 100%;
          }

          .input-group-prepend {
            margin-bottom: 5px;
            width: 100px;
            white-space: nowrap;
          }

          .file_wrap {
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>